module.exports = __webpack_public_path__ + "files/d6bb1dec066462440a768e11a721b8a6.svg";